export default __webpack_public_path__ + "static/media/import-csv-example-prices-fi.da33f86d.csv";